import moment from "moment";
import endpoints from "api/endpoints";
import axiosNeuron from "api/axios";

export async function addLabel({
  item,
  start,
  end,
  placements,
  timezoneOffset,
  eventId = null,
  machineId,
  value,
  startValue,
  endValue,
  intermediateValues,
}: {
  item: { name: string; subcategory: number };
  start: number;
  end: number;
  placements: number[];
  timezoneOffset: number;
  eventId: number | null;
  machineId?: number;
  value?: number | null;
  startValue?: number | null;
  endValue?: number | null;
  intermediateValues?: { datetime: number; value: number }[] | null;
}) {
  try {
    const start_datetime = moment.unix(start).format("YYYY-MM-DD HH:mm:ss.SSS");
    const end_datetime = moment.unix(end).format("YYYY-MM-DD HH:mm:ss.SSS");
    const intermediate_values =
      intermediateValues && intermediateValues.length
        ? intermediateValues.map((item) => ({
            datetime: moment
              .unix(item.datetime)
              .format("YYYY-MM-DD HH:mm:ss.SSS"),
            value: item.value,
          }))
        : undefined;
    const url = endpoints.labels.default;
    const labelData = {
      subcategory: item.subcategory,
      placements,
      machine: machineId,
      start_datetime,
      end_datetime,
      description: item.name,
      tz: timezoneOffset,
      event: eventId,
      value,
      start_value: startValue,
      end_value: endValue,
      intermediate_values,
    };

    const { data } = await axiosNeuron.post(
      `${url}?tz=${timezoneOffset}`,
      labelData
    );
    return data;
  } catch (error) {
    if (error !== undefined) {
      throw error;
    }
  }
}
